var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChatMic = function SvgChatMic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6524 13.487C13.1751 13.487 14.4044 12.2578 14.4044 10.735V5.23105C14.4044 3.70828 13.1751 2.47906 11.6524 2.47906C10.1296 2.47906 8.90039 3.70828 8.90039 5.23105V10.735C8.90039 12.2578 10.1296 13.487 11.6524 13.487ZM10.735 5.23105C10.735 4.72652 11.1478 4.31372 11.6524 4.31372C12.1569 4.31372 12.5697 4.72652 12.5697 5.23105V10.735C12.5697 11.2395 12.1569 11.6523 11.6524 11.6523C11.1478 11.6523 10.735 11.2395 10.735 10.735V5.23105ZM16.239 10.735C16.239 13.2668 14.1842 15.3217 11.6524 15.3217C9.12055 15.3217 7.06573 13.2668 7.06573 10.735H5.23108C5.23108 13.9732 7.6253 16.6334 10.735 17.0829V19.9083H12.5697V17.0829C15.6794 16.6334 18.0737 13.9732 18.0737 10.735H16.239Z",
    fill: "#8F97B9"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChatMic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat_mic.272c41dc.svg";
export { ForwardRef as ReactComponent };